<template>
  <!--
      作者：kmdshop
      描述：插件中心-分销-分销金额明细
  -->
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="记录类型">
          <el-select v-model="formInline.log_type" placeholder="请选择记录类型">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="订单佣金" value="order"></el-option>
            <el-option label="提现申请" value="withdraw"></el-option>
            <el-option label="提现驳回" value="withdraw_reject"></el-option>
            <el-option label="手动调整" value="manual"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="结算状态">
          <el-select v-model="formInline.is_settled" placeholder="请选择结算状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="formInline.pay_mode" placeholder="请选择支付方式">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="余额" value="balance"></el-option>
            <el-option label="微信" value="wechat"></el-option>
            <el-option label="支付宝" value="alipay"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="formInline.order_id" placeholder="请输入订单ID"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.search" placeholder="请输入用户昵称/姓名/手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(true)">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 统计卡片 -->
    <!-- <el-row :gutter="20" class="stats-row" v-if="tableData.length > 0">
      <el-col :span="6">
        <el-card class="stats-card" shadow="never">
          <div class="stats-item">
            <div class="stats-label">总收入金额</div>
            <div class="stats-value positive">{{ stats.total_income || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="never">
          <div class="stats-item">
            <div class="stats-label">总支出金额</div>
            <div class="stats-value negative">{{ stats.total_expense || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="never">
          <div class="stats-item">
            <div class="stats-label">未结算金额</div>
            <div class="stats-value warning">{{ stats.unsettled_amount || 0 }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="never">
          <div class="stats-item">
            <div class="stats-label">已结算金额</div>
            <div class="stats-value success">{{ stats.settled_amount || 0 }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
   
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="60"></el-table-column>
          <el-table-column label="用户信息" width="120">
            <template slot-scope="scope">
              <div class="user-info-cell" v-if="scope.row.user">
                <img class="radius" :src="scope.row.user.avatarUrl" width="30" height="30" />
                <div class="user-text">
                  <p class="nickname">{{ scope.row.user.nickName }}</p>
                  <p class="user-id">ID: {{ scope.row.user_id }}</p>
                  <p class="user-mobile" v-if="scope.row.user.mobile">{{ scope.row.user.mobile }}</p>
                </div>
              </div>
              <span v-else>用户已删除</span>
            </template>
          </el-table-column>
          <el-table-column label="记录类型" width="150">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.log_type.text }}</div>
                <div style="font-size: 12px; color: #909399;">类型值: {{ scope.row.log_type.value }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="金额" width="100">
            <template slot-scope="scope">
              <span :class="getAmountClass(scope.row.price)">{{ formatAmount(scope.row.price) }}</span>
            </template>
          </el-table-column>
         
         
          <el-table-column label="结算状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_settled ? 'success' : 'warning'" size="small">
                {{ scope.row.is_settled ? '已结算' : '未结算' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column prop="remark" label="备注" min-width="150">
            <template slot-scope="scope">
              <p class="text-ellipsis" :title="scope.row.remark">{{ scope.row.remark || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="viewDetail(scope.row)" type="text" size="small">查看详情</el-button>
              <el-button 
                v-if="!scope.row.is_settled && scope.row.price > 0" 
                @click="settleAmount(scope.row)" 
                type="text" 
                size="small"
                v-auth="'/plus/agent/log/settle'"
              >
                标记结算
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, prev, sizes, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog
      title="分销记录详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :before-close="handleDetailClose"
    >
      <div v-if="currentDetail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="记录ID">{{ currentDetail.id }}</el-descriptions-item>
          <el-descriptions-item label="用户ID">{{ currentDetail.user_id }}</el-descriptions-item>
          <el-descriptions-item label="记录类型">
            {{ currentDetail.log_type.text }} ({{ currentDetail.log_type.value }})
          </el-descriptions-item>
          <el-descriptions-item label="金额">
            <span :class="getAmountClass(currentDetail.price)">
              {{ formatAmount(currentDetail.price) }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="关联订单">{{ currentDetail.order_id || '--' }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">{{ currentDetail.pay_mode || '--' }}</el-descriptions-item>
          <el-descriptions-item label="结算状态">
            <el-tag :type="currentDetail.is_settled ? 'success' : 'warning'" size="small">
              {{ currentDetail.is_settled ? '已结算' : '未结算' }}
            </el-tag>
          </el-descriptions-item>
          <el-table-column prop="settle_time" label="结算时间" width="135">
            <template slot-scope="scope">
              {{ scope.row.settle_time || '--' }}
            </template>
          </el-table-column>
          <el-descriptions-item label="创建时间">{{ currentDetail.create_time }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{ currentDetail.update_time }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ currentDetail.remark || '--' }}</el-descriptions-item>
          <el-descriptions-item label="参数信息" :span="2">
            <pre class="params-pre">{{ formatParams(currentDetail.params) }}</pre>
          </el-descriptions-item>
        </el-descriptions>
        
        <!-- 用户信息 -->
        <el-card v-if="currentDetail.user" class="user-detail-card" style="margin-top: 20px;">
          <div slot="header">
            <span>用户信息</span>
          </div>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="用户ID">{{ currentDetail.user.user_id }}</el-descriptions-item>
            <el-descriptions-item label="昵称">{{ currentDetail.user.nickName }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ currentDetail.user.mobile || '--' }}</el-descriptions-item>
            <el-descriptions-item label="等级">{{ currentDetail.user.grade_id }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';

export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单*/
      formInline: {
        search: '',
        user_id: '',
        order_id: '',
        log_type: '-1',
        is_settled: '-1',
        pay_mode: '-1'
      },
      /*统计数据*/
      stats: {},
      /*详情对话框显示*/
      detailDialogVisible: false,
      /*当前查看的详情*/
      currentDetail: null
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.user_id != null) {
        this.formInline.user_id = to.query.user_id;
      } else {
        this.formInline.user_id = '';
      }
      this.curPage = 1;
      this.getData();
    }
  },
  created() {
    if (this.$route.query.user_id != null) {
      this.formInline.user_id = this.$route.query.user_id;
    }
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData(submit = false) {
      let self = this;
      self.loading = true;
      let Params = { ...self.formInline };
      Params.page = submit ? 1 : self.curPage;
      Params.list_rows = self.pageSize;
      
      PlusApi.agentLog(Params, true)
        .then(data => {
          self.loading = false;
          // 修正数据路径
          self.tableData = data.data.list || [];
          self.totalDataNumber = data.data.total || 0;
          
          // 计算统计信息
          self.calculateStats();
        })
        .catch(error => {
          self.loading = false;
          console.error('获取数据失败:', error);
        });
    },

    /*从列表数据计算统计信息*/
    calculateStats() {
      let total_income = 0;
      let total_expense = 0;
      let unsettled_amount = 0;
      let settled_amount = 0;

      this.tableData.forEach(item => {
        const amount = parseFloat(item.price) || 0;
        if (amount >= 0) {
          total_income += amount;
        } else {
          total_expense += Math.abs(amount);
        }

        if (item.is_settled) {
          settled_amount += Math.abs(amount);
        } else {
          unsettled_amount += Math.abs(amount);
        }
      });

      this.stats = {
        total_income: total_income.toFixed(2),
        total_expense: total_expense.toFixed(2),
        unsettled_amount: unsettled_amount.toFixed(2),
        settled_amount: settled_amount.toFixed(2)
      };
    },

    /*重置搜索*/
    resetSearch() {
      this.formInline = {
        search: '',
        user_id: this.$route.query.user_id || '',
        order_id: '',
        log_type: '-1',
        is_settled: '-1',
        pay_mode: '-1'
      };
      this.curPage = 1;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*查看详情*/
    viewDetail(row) {
      this.currentDetail = row;
      this.detailDialogVisible = true;
    },

    /*关闭详情对话框*/
    handleDetailClose() {
      this.detailDialogVisible = false;
      this.currentDetail = null;
    },

    /*标记结算*/
    settleAmount(row) {
      let self = this;
      self.$confirm('确认要标记为已结算吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        PlusApi.settleAgentLog({ id: row.id }, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '操作成功',
                type: 'success'
              });
              self.getData();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      }).catch(() => {});
    },

    /*查看订单*/
    viewOrder(orderId) {
      // 在新窗口打开订单详情页
      window.open(`/order/order/detail?order_id=${orderId}`, '_blank');
    },

    /*格式化金额显示*/
    formatAmount(amount) {
      if (!amount) return '¥0.00';
      const num = parseFloat(amount);
      return num >= 0 ? `+¥${num.toFixed(2)}` : `-¥${Math.abs(num).toFixed(2)}`;
    },

    /*获取金额样式类*/
    getAmountClass(amount) {
      const num = parseFloat(amount);
      return num >= 0 ? 'positive' : 'negative';
    },

    /*格式化参数信息*/
    formatParams(params) {
      if (!params) return '无';
      try {
        if (typeof params === 'string') {
          const parsed = JSON.parse(params);
          return JSON.stringify(parsed, null, 2);
        }
        return JSON.stringify(params, null, 2);
      } catch (e) {
        return params;
      }
    }
  }
};
</script>

<style scoped>
.stats-row {
  margin-bottom: 20px;
}

.stats-card {
  border-radius: 4px;
}

.stats-item {
  text-align: center;
  padding: 20px 0;
}

.stats-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stats-value {
  font-size: 24px;
  font-weight: bold;
}

.positive {
  color: #67C23A;
}

.negative {
  color: #F56C6C;
}

.warning {
  color: #E6A23C;
}

.success {
  color: #67C23A;
}

.user-info-cell {
  display: flex;
  align-items: center;
}

.user-info-cell img {
  margin-right: 8px;
  border-radius: 50%;
}

.user-text {
  flex: 1;
  min-width: 0;
}

.nickname {
  font-size: 12px;
  color: #303133;
  margin: 0;
  line-height: 1.4;
}

.user-id {
  font-size: 11px;
  color: #909399;
  margin: 0;
  line-height: 1.4;
}

.user-mobile {
  font-size: 11px;
  color: #909399;
  margin: 0;
  line-height: 1.4;
}

.params-pre {
  background: #f5f7fa;
  padding: 8px;
  border-radius: 4px;
  font-size: 12px;
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.radius {
  border-radius: 50%;
}

.user-detail-card {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/agent/amount/Amount.vue